import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { ArrowUp } from "lucide-react";
import moment from "moment";
import { Path } from "../../../../static/Constants";
import { colors, borderRadiusPx } from "../../../../theme";
import Pdf from "../../../Autobet_whitepaper.pdf";

const FooterBottom = () => {
  const currentYear = moment().year();

  const handleScrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const bottomLinks = [
    { label: "Terms & Conditions", path: Path.terms },
    { label: "Whitepaper", href: Pdf, isExternal: true },
    { label: "Help & FAQ", path: Path.help },
    { label: "About Us", path: Path.about },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        borderTop: `1px solid ${colors.sidebar.border}`,
        pt: 3,
        pb: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
      }}
      className="autobet-footer-bottom-row"
    >
      {/* Copyright Notice */}
      <Typography
        sx={{
          fontSize: "0.825rem",
          color: colors.slate[300],
          lineHeight: 1.5,
        }}
      >
        © {currentYear}{" "}
        <Box
          component="a"
          href={Path.root}
          sx={{
            color: colors.neutral.white,
            fontWeight: 600,
            textDecoration: "none",
            "&:hover": { color: colors.blue[400] },
          }}
        >
          AutoBET
        </Box>{" "}
        — All Rights Reserved. Decentralized Lottery Protocol.
      </Typography>

      {/* Legal & Helper Links */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 2, sm: 3 },
          flexWrap: "wrap",
        }}
        className="autobet-footer-bottom-links"
      >
        {bottomLinks.map((link) => (
          <Box
            key={link.label}
            component="a"
            href={link.path || link.href}
            target={link.isExternal ? "_blank" : undefined}
            rel={link.isExternal ? "noreferrer noopener" : undefined}
            sx={{
              fontSize: "0.8rem",
              color: colors.slate[300],
              textDecoration: "none",
              transition: "color 0.2s ease",
              "&:hover": {
                color: colors.neutral.white,
              },
            }}
          >
            {link.label}
          </Box>
        ))}

        {/* Scroll To Top Button */}
        <Tooltip title="Back to top" arrow placement="top">
          <Box
            component="button"
            type="button"
            onClick={handleScrollToTop}
            aria-label="Scroll to top"
            className="autobet-footer-scrolltop"
            sx={{
              borderRadius: borderRadiusPx.sm,
              backgroundColor: colors.alpha.white[5],
              border: `1px solid ${colors.sidebar.border}`,
              color: colors.slate[200],
              "&:hover": {
                backgroundColor: colors.primary.main,
                borderColor: colors.primary.main,
                color: colors.neutral.white,
              },
            }}
          >
            <ArrowUp size={16} />
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default FooterBottom;
